import React from 'react';
import { withStyles, Tabs as MuiTabs, Theme } from '@material-ui/core';

interface StyledTabsProps {
  value: number;
  onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}

const Tabs = withStyles((theme: Theme) => ({
  root: {
    padding: '0 20px',
    [theme.breakpoints.down('md')]: {
      padding: '0 15px',
    },
  },
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',

    '& > span': {
      width: '100%',
    },
  },
  flexContainer: {
    '& > button': {
      margin: 0,
      padding: 0,
      minWidth: 'auto',
      color: '#fff',
      fontSize: '1.8em',
      fontWeight: 'bold',
      [theme.breakpoints.down('md')]: {
        height: '65px',
      },
    },
  },
}))((props: StyledTabsProps) => <MuiTabs {...props} TabIndicatorProps={{ children: <span /> }} />);

export default Tabs;
